import axios from 'axios';
import { config } from '../../../helpers/config';
export const request = axios.create({
    baseURL: config.baseURL,
});
